import React, { useState, useEffect } from 'react';
import { db } from '../../firebase/firebase';
import { useDispatch, useSelector } from 'react-redux';
import { getDocs, collection, deleteDoc, doc, updateDoc } from 'firebase/firestore';
import { toast } from 'react-toastify';
import UserTable from "../../components/admin/userTable/UserTable";
import LoaderAI from '../../components/loader/Loader';
import ThreeDScene from '../../components/ThreeDScene'; 
import { SET_ALL_USERS, selectAllUsers } from '../../redux/slice/authSlice'; 

const AdminUserManagement = () => {
  const dispatch = useDispatch();
  const users = useSelector(selectAllUsers); 
  const [loadingUsers, setLoadingUsers] = useState(true); 

  const fetchAllUsers = async () => {
    try {
      setLoadingUsers(true);
      const usersCollectionRef = collection(db, 'users');
      const querySnapshot = await getDocs(usersCollectionRef);
      const usersList = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      dispatch(SET_ALL_USERS(usersList)); 
      console.log("[AdminUserManagement] Fetched users:", usersList);
    } catch (error) {
      console.error("Error fetching users for admin dashboard:", error);
      toast.error("Failed to load users for admin dashboard.");
    } finally {
      setLoadingUsers(false);
    }
  };

  useEffect(() => {
    // Only fetch if Redux store is empty or needs refresh
    if (users.length === 0) {
      fetchAllUsers();
    } else {
      setLoadingUsers(false); 
    }
  }, [dispatch, users.length]); 

  const handleDeleteUser = async (userId) => {
    if (window.confirm("Are you sure you want to delete this user's profile? This will NOT delete their Firebase Authentication account.")) {
      try {
        await deleteDoc(doc(db, 'users', userId));
        toast.success("User profile deleted successfully!");
        fetchAllUsers(); 
      } catch (error) {
        console.error("Error deleting user profile:", error);
        toast.error("Failed to delete user profile.");
      }
    }
  };

  const handleEditUser = async (userId, currentRole) => {
    const newRole = currentRole === 'admin' ? 'user' : 'admin';
    if (window.confirm(`Are you sure you want to change this user's role to "${newRole}"?`)) {
      try {
        await updateDoc(doc(db, 'users', userId), { role: newRole });
        toast.success(`User role updated to "${newRole}"!`);
        fetchAllUsers(); // Refetch to update the UI and Redux
      } catch (error) {
        console.error("Error updating user role:", error);
        toast.error("Failed to update user role.");
      }
    }
  };

  if (loadingUsers) {
    return <LoaderAI />;
  }

  return (
    <>
      <ThreeDScene /> 
      <h2>Manage Application Users</h2>
      <UserTable
        users={users}
        onDeleteUser={handleDeleteUser}
        onEditUser={handleEditUser}
      />
    </>
  );
};

export default AdminUserManagement;
